import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { withSnackbar } from "notistack";
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import LoadingButton from "../../components/Buttons/Loading";
import Header from "../../components/Typography/Header";
import store from "../../store";
import { sendUnsubscribeRequest } from "../../utils/appsyncOperations";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    position: "relative",
  },
  scrollable: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    overflowX: "hidden",
    overflowY: "auto",
  },
  paper: {
    margin: theme.spacing(3),
    padding: theme.spacing(3),
  },
  actions: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  button: {
    margin: theme.spacing(1),
  },
}));

const BillingContent = ({ enqueueSnackbar, serviceProviderId, user }) => {
  const classes = useStyles();

  const [
    cancelSubscriptionDialogOpen,
    setCancelSubscriptionDialogOpen,
  ] = useState(false);
  const [
    sendUnsubscribeRequestPending,
    setSendUnsubscribeRequestPending,
  ] = useState(false);

  const runSendUnsubscribeRequest = async () => {
    setSendUnsubscribeRequestPending(true);
    try {
      await sendUnsubscribeRequest({
        serviceProviderId,
        userId: user.username,
      });
      enqueueSnackbar("Your request to cancel the subscription has been sent", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar(error, { variant: "error" });
    }
    setSendUnsubscribeRequestPending(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.scrollable}>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item s={12} xs={12}>
              <Header label="Billing" />
            </Grid>
            <Grid item s={12} xs={12}>
              <Typography variant="h6">Subscription</Typography>
              <Typography>
                If you'd like to cancel your subscription, click below.
              </Typography>
            </Grid>
            <Grid item s={12} xs={12}>
              <Button
                color="primary"
                onClick={() => setCancelSubscriptionDialogOpen(true)}
                variant="contained"
              >
                Cancel Subscription
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </div>
      <Dialog
        open={cancelSubscriptionDialogOpen}
        onClose={() => setCancelSubscriptionDialogOpen(false)}
      >
        <DialogTitle>{"Confirm Cancellation"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            If you confirm, your cancellation will be processed and effective
            within 24 hours.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setCancelSubscriptionDialogOpen(false)}
            color="primary"
          >
            Not Now
          </Button>
          <LoadingButton
            color="primary"
            isLoading={sendUnsubscribeRequestPending}
            onClick={async () => {
              await runSendUnsubscribeRequest();
              setCancelSubscriptionDialogOpen(false);
            }}
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
  user: state.auth.user,
});

export default withRouter(
  withSnackbar(connect(mapStateToProps)(BillingContent))
);
